import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export async function submitContact(request: SubmitContactRequest) {
  const url = `${apiConfiguration.apiUrl}/contact`;
  await axios.post(url, request);
}